export default "__VITE_ASSET__94981d69__"